import { call, put, select } from 'redux-saga/effects';
import api from '../../../../../services/api';
import * as Actions from './actions';

export function* searchRequest() {
  try {
    const protocolo = yield select((state) => state.recepcaoReducer.protocolo);
    let response = {};
    if (protocolo === '') {
      response.data = [];
    } else {
      const body = {
        filter: {
          protocolo,
        },
      };
      const client = yield call(api, 'protocolo');
      response = yield call(client.post, 'consultasql/exec/recepcionar', body);
    }

    yield put(Actions.searchSuccess(response.data));
  } catch (error) {
    yield put(Actions.searchFailure());
  }
}
